import React from 'react';

import { SearchAcrossToolsItem } from '../components/SearchAcrossToolsItem.tsx';
import { useConnectorPromoConfig } from '../hooks/useConnectorPromoConfig.ts';

/**
 * Self-contained surface component for the sidebar.
 * Internally calls useConnectorPromoConfig and renders the SearchAcrossToolsItem.
 */
export function ConnectorPromoSidebar() {
	const config = useConnectorPromoConfig();

	if (!config.shouldShowSidebarItem) {
		return null;
	}

	return (
		<SearchAcrossToolsItem
			recommendedConnectors={config.recommendedConnectors}
			onSetupConnector={config.onSetupConnector}
			onDismiss={config.onDismissPromo}
			shouldShowSpotlight={config.shouldShowSpotlight}
			onDismissSpotlight={config.onDismissSpotlight}
		/>
	);
}
